export default __webpack_public_path__ + "static/media/img-20.88014e05.jpg";